import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
import isNull from 'lodash/isNull';
import omit from 'lodash/omit';
import set from 'lodash/set';
import AddressForm from '../AddressForm';
import ModalPortal from '../ModalPortal';
import BSDatepicker from '../BSDatepicker/BSDatepicker';
import moment from 'moment-timezone';
import Cleave from 'cleave.js/dist/cleave-react';
import US_STATES from '../../constants/usStates';
import './ModalClientDetails.css';

const propTypes = {
  client: PropTypes.object,
  isUpdatingClient: PropTypes.bool,
  onSubmit: PropTypes.func,
  isClientTypeVisible: PropTypes.bool,
  isEditingExistingClient: PropTypes.bool,
};

const defaultProps = {
  client: null,
  isUpdatingClient: false,
  onSubmit: () => {},
  isClientTypeVisible: true,
  isEditingExistingClient: false,
};

class ModalClientDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasMailingAddress: false,
      client: {},
    };
  }

  toggleAddMailingAddress = () => {
    if (this.state.hasMailingAddress) {
      this.setState({
        hasMailingAddress: false,
        client: omit(this.state.client, 'person.address'),
      });
    } else {
      this.setState({
        hasMailingAddress: true,
      });
    }
  };

  handleAddressUpdate = (e) => {
    const client = {
      ...this.state.client,
    };
    set(client.person, e.target.name, e.target.value);
    this.setState({
      client,
    });
  };

  handleNewClientUpdate = (e) => {
    const client = {
      ...this.state.client,
    };
    set(client, e.target.name, e.target.value);
    this.setState({
      client,
    });
  };

  handlePhoneInit = (cleave) => {
    this.cleave = cleave;
    cleave.setRawValue(get(this.props.client, 'person.phone_number'));
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const client = {
      ...this.state.client,
      person: {
        ...this.state.client.person,
        dob: this.state.client.person.dob
          ? moment(this.state.client.person.dob).format('YYYY-MM-DD')
          : null,
      },
    };
    if (isNull(client.person.address)) {
      delete client.person.address;
    }
    this.props.onSubmit(client);
  };

  hide = () => {
    this.setState({
      hasMailingAddress: false,
      client: {},
    });
    this.cleave.setRawValue('');
    window.$(this.modal).modal('hide');
  };

  show = () => {
    const client = this.props.client;
    if (client) {
      this.setState({
        client: {
          ...cloneDeep(client),
        },
        hasMailingAddress: !!get(client, 'person.address') || false,
      });
    }
    window.$(this.modal).modal('show');
  };

  get fieldsBusiness() {
    return (
      <div className="col-md-9">
        <div className="form-group p-t-0">
          <label htmlFor="company" className="text-uppercase">
            Business name
          </label>
          <input
            type="text"
            className="form-control"
            id="company"
            name="person.company_name"
            value={get(this.state.client, 'person.company_name') || ''}
            required
            aria-required="true"
            onChange={this.handleNewClientUpdate}
          />
        </div>
        <div className="form-group">
          <label htmlFor="firstName" className="text-uppercase">
            Owner's first name
          </label>
          <input
            type="text"
            className="form-control"
            id="firstName"
            name="person.first_name"
            value={get(this.state.client, 'person.first_name') || ''}
            required
            aria-required="true"
            onChange={this.handleNewClientUpdate}
          />
        </div>
        <div className="form-group">
          <label htmlFor="lastName" className="text-uppercase">
            Owner's last name
          </label>
          <input
            type="text"
            className="form-control"
            id="lastName"
            name="person.last_name"
            value={get(this.state.client, 'person.last_name') || ''}
            required
            aria-required="true"
            onChange={this.handleNewClientUpdate}
          />
        </div>
        <div className="form-group">
          <label htmlFor="email" className="text-uppercase">
            Owner's email
          </label>
          <input
            type="text"
            className="form-control"
            id="email"
            name="person.email"
            value={get(this.state.client, 'person.email') || ''}
            required
            aria-required="true"
            onChange={this.handleNewClientUpdate}
          />
        </div>
        <div className="form-group">
          <label htmlFor="phone" className="text-uppercase">
            Owner's phone
          </label>
          <Cleave
            id="phone"
            className="form-control"
            name="person.phone_number"
            required
            options={{
              blocks: [3, 3, 4],
              delimiter: '-',
              numericOnly: true,
            }}
            value={get(this.state.client, 'person.phone_number') || ''}
            onInit={this.handlePhoneInit}
            onChange={this.handleNewClientUpdate}
          />
        </div>
        <div className="form-group">
          <label htmlFor="dob" className="text-uppercase">
            Owner's date of birth
          </label>
          <BSDatepicker
            type="text"
            className="form-control"
            id="dob"
            name="person.dob"
            placeholder="mm/dd/yyyy"
            aria-describedby="dob"
            value={
              (get(this.state.client, 'person.dob') &&
                moment(get(this.state.client, 'person.dob')).format(
                  'MM/DD/YYYY'
                )) ||
              'N/A'
            }
            datepickerOpts={{
              autoclose: true,
              forceParse: false,
              defaultViewDate: get(this.state.client, 'person.dob'),
              startView: 'decade',
              endDate: moment().toISOString(),
            }}
            onChange={this.handleNewClientUpdate}
          />
        </div>
      </div>
    );
  }

  get fieldsIndividual() {
    return (
      <div className="col-md-9">
        <div className="form-group">
          <label htmlFor="firstName" className="text-uppercase">
            First name
          </label>
          <input
            type="text"
            className="form-control"
            id="firstName"
            name="person.first_name"
            value={get(this.state.client, 'person.first_name') || ''}
            required
            aria-required="true"
            onChange={this.handleNewClientUpdate}
          />
        </div>
        <div className="form-group">
          <label htmlFor="lastName" className="text-uppercase">
            Last name
          </label>
          <input
            type="text"
            className="form-control"
            id="lastName"
            name="person.last_name"
            value={get(this.state.client, 'person.last_name') || ''}
            required
            aria-required="true"
            onChange={this.handleNewClientUpdate}
          />
        </div>
        <div className="form-group">
          <label htmlFor="email" className="text-uppercase">
            Email
          </label>
          <input
            type="text"
            className="form-control"
            id="email"
            name="person.email"
            value={get(this.state.client, 'person.email') || ''}
            required
            aria-required="true"
            onChange={this.handleNewClientUpdate}
          />
        </div>
        <div className="form-group">
          <label htmlFor="phone" className="text-uppercase">
            Phone (optional)
          </label>
          <Cleave
            id="phone"
            className="form-control"
            name="person.phone_number"
            options={{
              blocks: [3, 3, 4],
              delimiter: '-',
              numericOnly: true,
            }}
            value={get(this.state.client, 'person.phone_number') || ''}
            onInit={this.handlePhoneInit}
            onChange={this.handleNewClientUpdate}
          />
        </div>
        <div className="form-group">
          <label htmlFor="dob" className="text-uppercase">
            Date of birth
          </label>
          <BSDatepicker
            type="text"
            className="form-control"
            id="dob"
            name="person.dob"
            placeholder="mm/dd/yyyy"
            aria-describedby="dob"
            value={
              (get(this.state.client, 'person.dob') &&
                moment(get(this.state.client, 'person.dob')).format(
                  'MM/DD/YYYY'
                )) ||
              'N/A'
            }
            datepickerOpts={{
              autoclose: true,
              forceParse: false,
              defaultViewDate: get(this.state.client, 'person.dob'),
              startView: 'decade',
              endDate: moment().toISOString(),
            }}
            onChange={this.handleNewClientUpdate}
          />
        </div>
        <div className="form-group p-t-0">
          <label htmlFor="company" className="text-uppercase">
            Business name (optional)
          </label>
          <input
            type="text"
            className="form-control"
            id="company"
            name="person.company_name"
            value={get(this.state.client, 'person.company_name') || ''}
            aria-required="true"
            onChange={this.handleNewClientUpdate}
          />
        </div>
      </div>
    );
  }

  get stateOptions() {
    return US_STATES.map(([code, label]) => (
      <option key={code} value={code}>
        {label}
      </option>
    ));
  }

  render() {
    const isBusiness = get(this.state.client, 'client_type') === 'business';
    const { isClientTypeVisible, isEditingExistingClient } = this.props;
    return (
      <ModalPortal>
        <div
          className="modal"
          id="clientDetailsModal"
          ref={(c) => (this.modal = c)}
        >
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content-wrapper">
              <form
                className="form"
                onSubmit={this.handleSubmit}
                ref={(c) => (this.formNode = c)}
              >
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">
                      {this.props.client ? 'Edit' : 'Add'} a client
                    </h5>
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div className="modal-body">
                    {!isEditingExistingClient && (
                      <p>
                        Please supply all required information to successfully
                        add a new client to your list.
                      </p>
                    )}
                    {isClientTypeVisible && (
                      <>
                        <div className="form-group row">
                          <label className="col-md-3 text-uppercase">
                            Type of client
                          </label>
                          <div className="col-md-9">
                            <div className="radio radio-success m-t-0">
                              <input
                                id="radioIndividual"
                                type="radio"
                                name="client_type"
                                value="individual"
                                required
                                checked={!isBusiness}
                                onChange={this.handleNewClientUpdate}
                              />
                              <label
                                className="form-check-label text-black"
                                htmlFor="radioIndividual"
                              >
                                <strong>Individual</strong>
                              </label>
                            </div>
                            <div className="radio radio-success">
                              <input
                                id="radioBusiness"
                                type="radio"
                                name="client_type"
                                value="business"
                                required
                                checked={isBusiness}
                                onChange={this.handleNewClientUpdate}
                              />
                              <label
                                className="form-check-label text-black"
                                htmlFor="radioBusiness"
                              >
                                <strong>Business</strong>
                              </label>
                            </div>
                          </div>
                        </div>
                        <hr />
                      </>
                    )}
                    <div className="form-group row">
                      <label className="col-md-3 text-uppercase">
                        Policyholder details
                      </label>
                      {isBusiness ? this.fieldsBusiness : this.fieldsIndividual}
                    </div>
                    <hr />
                    <div className="form-group row">
                      <label className="col-md-3 text-uppercase">
                        {isBusiness ? 'Business' : 'Home'} address (optional)
                      </label>
                      <div className="col-md-9">
                        {this.state.hasMailingAddress ? (
                          <div className="ModalClientDetails-addAddressWrapper">
                            <button
                              type="button"
                              className="ModalClientDetails-addAddressWrapper-close"
                              onClick={this.toggleAddMailingAddress}
                            >
                              <i className="fa fa-times" />
                            </button>
                            <AddressForm
                              address={get(this.state.client, 'person.address')}
                              onChange={this.handleAddressUpdate}
                            />
                          </div>
                        ) : (
                          <button
                            type="button"
                            className="btn btn-sm"
                            onClick={this.toggleAddMailingAddress}
                          >
                            <i className="fa fa-plus" /> Add address
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      data-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn btn-complete"
                      disabled={this.props.isUpdatingClient}
                    >
                      Save
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </ModalPortal>
    );
  }
}

ModalClientDetails.propTypes = propTypes;
ModalClientDetails.defaultProps = defaultProps;

export default ModalClientDetails;
